import React, { useEffect, useState, useContext } from 'react';
import { ConfigContext } from '../../DynamicForm/DynamicForm';
import { ErrorMessage } from "formik";
import Markdown from "markdown-to-jsx";
import { Field } from "formik";
import Required from "../../../../components/Required";
import { SectionHeader } from '../../../../components/sectionHeader/sectionHeader';
import { SelfieIcon, IDIcon, UploadIcon, CloseIcon, DocumentIcon } from '../../styles/assets/icons';
import ErrorBar from '../../../../components/ErrorBar';
import './SupportingDocsSection.scss';
import RadioField from '../../../../components/RadioField2/RadioField';
import SectionInstruction from '../../../../components/sectionInstruction/view';
import { GetLanguageText } from '../../../../languages/languages';
import { CheckLanguage } from '../../../../languages/languages';


export const ProxySupportingDocsSection = ({ fileSubmissionAction, fileDeletionAction }) => {
    // state values
    const [error, giveError] = useState(false);
    const [screenWidth, setScreenWidth] = useState(0);
    const [fileError, setFileError] = useState({ status: false, errorDisplay: 'none' });

    // context object
    const { formik, validationValues, dbFormSpec, formType, devMode } = useContext(ConfigContext);

    // local variables
    const template = { section: validationValues.page.form.sections.supportingDocsSection, styles: { ...validationValues.page.form.styles } };
    const fileColor = dbFormSpec.color + '0d';
    const orgId = dbFormSpec.facility.orgId;
    const triPartiteOrg = orgId.includes('7042') || orgId.includes('7101') || orgId.includes('7239')

    function dragOverHandler(ev) {
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();
    }

    function dropHandler(ev) {
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();

        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (ev.dataTransfer.items[i].kind === 'file') {
                    var file = ev.dataTransfer.items[i].getAsFile();
                    fileSubmissionAction(ev.dataTransfer.items[i].getAsFile());
                    formik.setFieldValue('supportingDocProxy', [...formik.values.supportingDocProxy, ev.dataTransfer.items[i].getAsFile()])

                }
            }
        } else {

        }
    }

    useEffect(() => {
        // fileError.status && setFileError({...fileError, status: false})
        // setTimeout(()=>{fileError.status && setFileError({...fileError, status: false})}, 8000)
    }, [fileError.status]);

    useEffect(() => {
        setScreenWidth(document.getElementsByTagName('body')[0].clientWidth)
        window.onresize = () => {
            setScreenWidth(document.getElementsByTagName('body')[0].clientWidth)
        }
    }, []);


    if (dbFormSpec.idVerificationProxy && dbFormSpec.idVerificationProxy.active === false) {
        return (<></>);
    }

    // make this fall back on translated text.
    const languageID = CheckLanguage(dbFormSpec);
    const languageText = GetLanguageText(languageID);


    // Custom text section.  Pulls from custom options, then translated text, then hardcoded english text.
    if (dbFormSpec.idVerificationProxy && dbFormSpec.idVerificationProxy.UseCustom) {
        let instructionText = dbFormSpec.idVerificationProxy.instructionText || (languageID !== "default" ? languageText.RepInfoSection.IdentityVerificationSection.options.label : "You may need to provide supporting documentation to confirm your relationship to the patient. How would you like to provide this?");
        let uploadNowText = dbFormSpec.idVerificationProxy.uploadNowText || (languageID !== "default" ? languageText.RepInfoSection.IdentityVerificationSection.options.optionone
            : "I would like to upload supporting documentation now");
        let onFileText = dbFormSpec.idVerificationProxy.onFileText || (languageID !== "default" ? languageText.RepInfoSection.IdentityVerificationSection.options.optiontwo
            : "The facility has documented proof of my relationship to the patient on file");
        // let declineText = dbFormSpec.idVerificationProxy.declineText || "I decline to upload documentation";
        let TouchAndUploadText = dbFormSpec.idVerificationProxy.TouchAndUploadText || (languageID !== "default" ? languageText.IdentityVerification.instructions.TouchAndUpload
            : "Touch to upload files");
        let DragAndDropText = dbFormSpec.idVerificationProxy.DragAndDropText || (languageID !== "default" ? languageText.IdentityVerification.instructions.DragAndDrop
            : "Drag & drop or Click to browse");
        let uploadMsg = dbFormSpec.idVerificationProxy.uploadMsg || (languageID !== "default" ? languageText.IdentityVerification.instructions.OnlyPDFs
            : "Only PDFs and Images may be uploaded");
        let maxFileSizeMsg = dbFormSpec.idVerificationProxy.maxFileSizeMsg || (languageID !== "default" ? languageText.IdentityVerification.instructions.MaxSize
            : "Maximum file size is 15mb");
        let SectionTitleText = dbFormSpec.idVerificationProxy.SectionTitleText || (languageID !== "default" ? languageText.ProxyDocumentation.sectionHeader
            : "Relationship to Patient Identity Verification");

        let VerifyLabelText = dbFormSpec.idVerificationProxy.VerifyLabel || (languageID !== "default" ? languageText.ProxyDocumentation.VerifyLabel
            : "To verify your relationship to the patient, please upload the following documentation:");
        let DocumentLabelText = dbFormSpec.idVerificationProxy.DocumentLabel || (languageID !== "default" ? languageText.ProxyDocumentation.DocumentLabel : "A document supporting the authorization validation process, such as Medical Power of Attorney, Will, Proof of Guardianship, or Letter of Representation.");


        return (
            <div id="supportingDocSection" className="form-section">
                <div id="supportingDocProxy"></div>
                <div id="documentationProxy"></div>
                <SectionHeader sectionTitle={SectionTitleText} styles={{ color: dbFormSpec.color }} />
                {formik.errors.documentationProxy && formik.touched.documentationProxy &&
                    <ErrorBar message={formik.errors.documentationProxy} />
                }
                {formik.errors.supportingDocProxy && (formik.values.documentationProxy === '1') && formik.touched.supportingDocProxy &&
                    <ErrorBar message={formik.errors.supportingDocProxy} />
                }
                {fileError.status && <ErrorBar message={fileError.message} />}
                <div id='section-content'>
                    {
                        dbFormSpec.idVerificationProxy.options ?
                            <div id='upload-radio-options'>
                                <SectionInstruction instructionText={instructionText} />
                                {dbFormSpec.idVerificationProxy.options.map((doc, index) => {
                                    return (
                                        doc.active && <RadioField key={'idVerificationProxy' + index} label={doc.label} id={'documentationProxy'} fieldValue={doc.value} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                    )
                                })}

                            </div>
                            :
                            <div id='upload-radio-options'>
                                <SectionInstruction instructionText={instructionText} />
                                <RadioField label={uploadNowText} id={'documentationProxy'} fieldValue={'1'} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                <RadioField label={onFileText} id={'documentationProxy'} fieldValue={'3'} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                            </div>

                    }


                    {(formik.values.documentationProxy === '1') &&
                        <div id='upload-instructions-and-field' style={formType === 'Representative' ? { marginTop: 40 } : {}}>
                            <div id='instructions-container'>
                                <label className='section-instruction subtitle1'>  </label>
                                <div className="id-instructions">
                                    <div className="instruction-item body1" style={{ display: 'flex', marginBottom: 26 }}>
                                        <IDIcon />
                                        <p>{VerifyLabelText}</p>
                                    </div>

                                    {
                                        dbFormSpec.idVerificationProxy.selfie.active &&
                                        <div className="instruction-item body1" style={{ display: 'flex' }}>
                                            <DocumentIcon />
                                            <p>{DocumentLabelText}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div id='ID-file-input-container' className='file-input'>
                                <div className='file-input-instruction'>
                                    <UploadIcon />
                                    {screenWidth < 1024 ? <p className='body1'>{TouchAndUploadText} </p> : <p className='body1'> {DragAndDropText} </p>}
                                </div>

                                <input
                                    id="ID-file-input"
                                    multiple
                                    onDrop={(e) => { dropHandler(e) }}
                                    onDragOver={(e) => { dragOverHandler(e) }}
                                    name="supportingDocProxy"
                                    type="file"

                                    onChange={(event) => {
                                        event.preventDefault()
                                        devMode && console.log("File", event)

                                        const arrayOfFiles = Object.values(event.currentTarget.files);

                                        if (arrayOfFiles.some((file) => { return !['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            setFileError({ status: 'size', message: uploadMsg })
                                        }
                                        if (arrayOfFiles.some((file) => { return file.size >= 15000000 })) {
                                            setFileError({ status: 'size', message: maxFileSizeMsg })
                                        }
                                        if (arrayOfFiles.length > 0 && arrayOfFiles.every((file) => { return file.size < 15000000 }) && arrayOfFiles.every((file) => { return ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            giveError(false);
                                            setFileError({ ...fileError, status: false })

                                            if (!formik.getFieldProps("supportingDocProxy").value) {
                                                formik.setFieldTouched("supportingDocProxy", true, true);
                                                formik.setFieldValue("supportingDocProxy",

                                                    arrayOfFiles,
                                                );

                                            } else {
                                                formik.setFieldTouched("supportingDocProxy", true, true);
                                                formik.setFieldValue(
                                                    "supportingDocProxy",
                                                    formik
                                                        .getFieldProps("supportingDocProxy")
                                                        .value.concat(arrayOfFiles)
                                                );
                                                // console.log(event.currentTarget.files[0]);
                                                fileSubmissionAction(event.currentTarget.files[0]);
                                            }
                                        }
                                        else {
                                            giveError(template.section.fields.supportingDoc.validations.fileSize.message);
                                        }
                                        document.getElementById('ID-file-input').value = ''
                                    }}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='uploads-container'>
                    {formik.getFieldProps("supportingDocProxy").value &&
                        formik.getFieldProps("supportingDocProxy").value.map((item, index, array) => {

                            if (array[0] instanceof File) {
                                return (
                                    <UploadedFileTab item={item} formik={formik} fileDeletionAction={fileDeletionAction} key={index} />
                                );
                            }
                        })}

                </div>
            </div>
        );
    }




    if (languageID != "default") {

        const languageText = GetLanguageText(languageID); return (
            <div id="supportingDocSection" className="form-section">

                <div id="supportingDocProxy"></div>
                <div id="documentationProxy"></div>
                <SectionHeader sectionTitle={`${languageText.RepInfoSection.IdentityVerificationSection.sectionHeader}`} styles={{ color: dbFormSpec.color }} />


                {formik.errors.documentationProxy && formik.touched.documentationProxy &&
                    <ErrorBar message={formik.errors.documentationProxy} />
                }
                {formik.errors.supportingDocProxy && formik.touched.supportingDocProxy && (formik.values.documentationProxy === '1') &&
                    <ErrorBar message={formik.errors.supportingDocProxy} />
                }

                {fileError.status && <ErrorBar message={fileError.message} />}
                <div id='section-content'>
                    {
                        dbFormSpec.idVerificationProxy && dbFormSpec.idVerificationProxy.options ?
                            dbFormSpec.idVerificationProxy.options.map((doc) => {
                                return (
                                    doc.active && <RadioField label={doc.label} id={'documentationProxy'} fieldValue={doc.value} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                )
                            })
                            :
                            <div id='upload-radio-options'>
                                <SectionInstruction instructionText={`${languageText.RepInfoSection.IdentityVerificationSection.options.label}`} />
                                <RadioField label={`${languageText.RepInfoSection.IdentityVerificationSection.options.optionone}`} id={'documentationProxy'} fieldValue={'1'} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                <RadioField label={`${languageText.RepInfoSection.IdentityVerificationSection.options.optiontwo}`} id={'documentationProxy'} fieldValue={'3'} formValue={'documentation'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                {triPartiteOrg && <RadioField label={'I decline to upload documentation'} id={'documentationProxy'} fieldValue={'2'} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />}
                                {/* {orgId != '1007451' && <RadioField label={'I will provide supporting documentation directly to the facility'} id={'documentation'} fieldValue={'4'} formValue={'documentation'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError}/>} */}
                            </div>

                    }

                    {(formType === "Patient" || formik.values.documentationProxy === '1') &&
                        <div id='upload-instructions-and-field' style={formType === 'Representative' ? { marginTop: 40 } : {}}>
                            <div id='instructions-container'>
                                <label className='section-instruction subtitle1'> {languageText.IdentityVerification.instructions.verifyUpload} </label>
                                <div className="id-instructions">
                                    <div className="instruction-item body1" style={{ display: 'flex', marginBottom: 26 }}>
                                    </div>
                                    {
                                        <div className="instruction-item body1" style={{ display: 'flex' }}>
                                            <DocumentIcon />
                                            <p>{languageText.IdentityVerification.instructions.SupportingDocument}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div id='ID-file-input-container' className='file-input'>
                                <div className='file-input-instruction'>
                                    <UploadIcon />
                                    {screenWidth < 1024 ? <p className='body1'>{languageText.IdentityVerification.instructions.TouchAndUpload}</p> : <p className='body1'>{languageText.IdentityVerification.instructions.DragAndDrop}</p>}
                                </div>

                                <input
                                    id="ID-file-input"
                                    multiple
                                    onDrop={(e) => { dropHandler(e) }}
                                    onDragOver={(e) => { dragOverHandler(e) }}
                                    name="supportingDocProxy"
                                    type="file"

                                    onChange={(event) => {
                                        event.preventDefault()
                                        devMode && console.log("File", event)

                                        const arrayOfFiles = Object.values(event.currentTarget.files)

                                        if (arrayOfFiles.some((file) => { return !['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            setFileError({ status: 'size', message: `${languageText.ErrorChecking.ValidatorText.fileType}` })
                                        }
                                        if (arrayOfFiles.some((file) => { return file.size >= 15000000 })) {
                                            setFileError({ status: 'size', message: `${languageText.ErrorChecking.ValidatorText.fileSize}` })
                                        }
                                        if (arrayOfFiles.length > 0 && arrayOfFiles.every((file) => { return file.size < 15000000 }) && arrayOfFiles.every((file) => { return ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            giveError(false);
                                            setFileError({ ...fileError, status: false })
                                            // console.log(formik.getFieldProps('supportingDoc').value)
                                            if (!formik.getFieldProps("supportingDocProxy").value) {
                                                formik.setFieldTouched("supportingDocProxy", true, true);
                                                formik.setFieldValue("supportingDocProxy",
                                                    // event.currentTarget.files[0],
                                                    arrayOfFiles,
                                                );

                                            } else {
                                                formik.setFieldTouched("supportingDocProxy", true, true);
                                                formik.setFieldValue(
                                                    "supportingDocProxy",
                                                    formik
                                                        .getFieldProps("supportingDocProxy")
                                                        .value.concat(arrayOfFiles)
                                                );
                                                // console.log(event.currentTarget.files[0]);

                                                fileSubmissionAction(event.currentTarget.files[0]);
                                                // }
                                            }

                                        }
                                        else {
                                            giveError(template.section.fields.supportingDoc.validations.fileSize.message);
                                        }
                                        document.getElementById('ID-file-input').value = ''

                                    }}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='uploads-container'>
                    {formik.getFieldProps("supportingDocProxy").value &&
                        formik.getFieldProps("supportingDocProxy").value.map((item, index, array) => {
                            // console.log(array)
                            if (array[0] instanceof File) {
                                return (
                                    <UploadedFileTab item={item} formik={formik} fileDeletionAction={fileDeletionAction} key={index} />
                                );
                            }
                        })}

                </div>
            </div>
        );
    } else {


        return (
            <div id="supportingDocSection" className="form-section">
                <div id="supportingDocProxy"></div>
                <div id="documentationProxy"></div>
                <SectionHeader sectionTitle={'Relationship to Patient Identity Verification'} styles={{ color: dbFormSpec.color }} />

                {formik.errors.documentationProxy && formik.touched.documentationProxy &&
                    <ErrorBar message={formik.errors.documentationProxy} />
                }
                {formik.errors.supportingDocProxy && formik.touched.supportingDocProxy && (formik.values.documentationProxy === '1') &&
                    <ErrorBar message={formik.errors.supportingDocProxy} />
                }
                {fileError.status && <ErrorBar message={fileError.message} />}
                <div id='section-content'>
                    {
                        dbFormSpec.idVerificationProxy && dbFormSpec.idVerificationProxy.options ?
                            dbFormSpec.idVerificationProxy.options.map((doc, index) => {
                                return (
                                    doc.active && <RadioField label={doc.label} key={index} id={'documentationProxy'} fieldValue={doc.value} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                )
                            })
                            :
                            <div id='upload-radio-options'>
                                <SectionInstruction instructionText={'You may need to provide supporting documentation to confirm your relationship to the patient. How would you like to provide this?'} />
                                <RadioField label={'I would like to upload supporting documentation now'} id={'documentationProxy'} fieldValue={'1'} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                <RadioField label={'The facility has documented proof of my relationship to the patient on file'} id={'documentationProxy'} fieldValue={'3'} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />
                                {triPartiteOrg && <RadioField label={'I decline to upload documentation'} id={'documentationProxy'} fieldValue={'2'} formValue={'documentationProxy'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError} />}
                                {/* {orgId != '1007451' && <RadioField label={'I will provide supporting documentation directly to the facility'} id={'documentation'} fieldValue={'4'} formValue={'documentation'} formik={formik} orgColor={dbFormSpec.color} setFileError={setFileError}/>} */}
                            </div>

                    }

                    {(formik.values.documentationProxy === '1') &&
                        <div id='upload-instructions-and-field' style={formType === 'Representative' ? { marginTop: 40 } : {}}>
                            <div id='instructions-container'>
                                <label className='section-instruction subtitle1'>To verify your relationship to the patient, please upload the following file(s): </label>
                                <div className="id-instructions">
                                    <div className="instruction-item body1" style={{ display: 'flex', marginBottom: 26 }}>

                                    </div>

                                    {
                                        <div className="instruction-item body1" style={{ display: 'flex' }}>
                                            <DocumentIcon />
                                            <p>A document supporting the authorization validation process, such as Medical Power of Attorney, Will, Proof of Guardianship, or Letter of Representation</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div id='ID-file-input-container' className='file-input'>
                                <div className='file-input-instruction'>
                                    <UploadIcon />
                                    {screenWidth < 1024 ? <p className='body1'>Touch to upload files</p> : <p className='body1'>Drag & drop or Click to browse</p>}
                                </div>

                                <input
                                    id="ID-file-input"
                                    multiple
                                    onDrop={(e) => { dropHandler(e) }}
                                    onDragOver={(e) => { dragOverHandler(e) }}
                                    name="supportingDocProxy"
                                    type="file"

                                    onChange={(event) => {
                                        event.preventDefault()
                                        devMode && console.log("File", event)
                                        // console.log(Object.values(event.currentTarget.files));
                                        const arrayOfFiles = Object.values(event.currentTarget.files)

                                        // if (event.currentTarget.files[0] && event.currentTarget.files[0].size < 15000000) {

                                        if (arrayOfFiles.some((file) => { return !['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            setFileError({ status: 'size', message: 'Only PDFs and Images may be uploaded' })
                                        }
                                        if (arrayOfFiles.some((file) => { return file.size >= 15000000 })) {
                                            setFileError({ status: 'size', message: 'Maximum file size is 15mb' })
                                        }
                                        if (arrayOfFiles.length > 0 && arrayOfFiles.every((file) => { return file.size < 15000000 }) && arrayOfFiles.every((file) => { return ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            giveError(false);
                                            setFileError({ ...fileError, status: false })
                                            // console.log(formik.getFieldProps('supportingDoc').value)
                                            if (!formik.getFieldProps("supportingDocProxy").value) {
                                                formik.setFieldTouched("supportingDocProxy", true, true);
                                                formik.setFieldValue("supportingDocProxy",
                                                    // event.currentTarget.files[0],
                                                    arrayOfFiles,
                                                );
                                                // console.log(event.currentTarget.files);
                                                // fileSubmissionAction(event.currentTarget.files[0]);
                                            } else {
                                                formik.setFieldTouched("supportingDocProxy", true, true);
                                                formik.setFieldValue(
                                                    "supportingDocProxy",
                                                    formik
                                                        .getFieldProps("supportingDocProxy")
                                                        // .value.concat(event.currentTarget.files[0])
                                                        .value.concat(arrayOfFiles)
                                                );
                                                // console.log(event.currentTarget.files[0]);
                                                // console.log(event.currentTarget.files);
                                                fileSubmissionAction(event.currentTarget.files[0]);
                                                // }
                                            }
                                            // else if (arrayOfFiles.length < 3) {
                                            //   giveError('Please upload a maximum of three files')
                                        }
                                        else {
                                            giveError(template.section.fields.supportingDoc.validations.fileSize.message);
                                        }
                                        document.getElementById('ID-file-input').value = ''

                                    }}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='uploads-container'>
                    {formik.getFieldProps("supportingDocProxy").value &&
                        formik.getFieldProps("supportingDocProxy").value.map((item, index, array) => {
                            // console.log(array)
                            if (array[0] instanceof File) {
                                return (
                                    <UploadedFileTab item={item} formik={formik} fileDeletionAction={fileDeletionAction} key={index} />
                                );
                            }
                        })}

                </div>
            </div>
        );
    }
};







const UploadedFileTab = ({ item, formik, fileDeletionAction }) => {

    const roundedSize = item.size.toFixed(1);
    const bItem = item.size.toFixed(1) + 'b';
    const kbItem = (item.size / 1024).toFixed(1) + 'kb';
    const mbItem = (item.size / 1048576).toFixed(1) + 'mb';

    return (
        <li className="uploaded-file-tab" style={item.size > 1.5e+7 ? { background: '#C10000', color: 'white' } : { border: 'none' }}>
            <span>
                {item.name}
                {'   '}
                <span>{`${item.size < 1024 ? bItem : item.size < 104856 ? kbItem : mbItem}`}</span>
            </span>

            <CloseIcon onClick={() => {
                formik.validateForm();
                formik.setFieldValue(
                    "supportingDocProxy",
                    formik
                        .getFieldProps("supportingDocProxy")
                        .value.filter((x) => x != item)
                );
                fileDeletionAction(item.name);
                // console.log(document.getElementById('ID-file-input').value)
            }} />
        </li>
    )
}
